import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import apiClient from '../api';
import MeterTable from '../components/MeterTable';
import AddMetersModal from '../components/AddMetersModal';
import './pages.css';
import './MetersPage.css';

const MetersPage = () => {
    const { serviceId } = useParams();
    const navigate = useNavigate();
    const [meters, setMeters] = useState([]);
    const [service, setService] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchServiceAndMeters();
    }, [serviceId]);

    const fetchServiceAndMeters = async () => {
        try {
            setLoading(true);
            
            // Получаем информацию об услуге
            const serviceResponse = await apiClient.get(`/services/${serviceId}`);
            setService(serviceResponse.data);

            // Получаем счетчики для этой услуги
            const metersResponse = await apiClient.get(`/meters/service/${serviceId}`);
            setMeters(metersResponse.data);
            console.log('Fetched meters:', metersResponse.data);
        } catch (error) {
            console.error('Ошибка загрузки данных:', error);
            alert('Не удалось загрузить данные');
            navigate('/');
        } finally {
            setLoading(false);
        }
    };

    const handleBackClick = () => {
        navigate(-1);
    }; 

    const [isAddModalOpen, setIsAddModalOpen] = useState(false);

    const handleAddClick = () => {
        setIsAddModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsAddModalOpen(false);
    };

    const handleSaveReadings = async (payload /* array of {index, reading, date} */) => {
        try {
            // Группируем показания по дате (хотя AddMetersModal отправляет только одну дату)
            const date = payload[0].date;
            const readings = payload.map(item => ({
                index: item.index,
                reading: item.reading,
            }));

            // Отправляем одну запись с массивом readings
            await apiClient.post('/meters', {
                service_id: parseInt(serviceId, 10),
                readings: readings,
                date: date,
            });

            await fetchServiceAndMeters();
            setIsAddModalOpen(false);
        } catch (error) {
            console.error('Ошибка сохранения показаний:', error);
            throw error;
        }
    };

        if (loading) { 
                return (
            <div className="page">
                <div className="loading">Загрузка...</div>
            </div>
        );
        }

    return (
        <div className="page">
            <div className="page-header">
                <button className="back-button" onClick={handleBackClick}>
                    ← Назад к услугам
                </button>
                <h1 className="page-title">Счетчики для услуги: {service ? service.name : ''}</h1>
            </div>

            <div className="table-actions">
                <button className="add-button" onClick={handleAddClick}>
                    Добавить показания
                </button>
            </div>

            <div style={{ marginTop: 12 }}>
                <MeterTable meters={meters} service={service} />
            </div>

            <AddMetersModal
                isOpen={isAddModalOpen}
                onClose={handleCloseModal}
                meters={meters}
                service={service}
                onSave={handleSaveReadings}
            />
        </div>
    );      
};

export default MetersPage;